module.exports = __webpack_public_path__ + "static/media/chip.d1abf969.png";